import swipeEvents from './swipeEvents';
import swipeTypes from './swipeTypes';
import displayMode from './displayMode';
import { DateTime } from 'luxon';

export default class SwipeEngine {

    validateVisitorPassCompetence(pass) {

        let reasonID = null;
        let reasonDescription = null;

        if (pass.isInvalidSite) {
            reasonID = swipeEvents.VP_INVALID_SITE_ID;
            reasonDescription = swipeEvents.VP_INVALID_SITE_MESSAGE;
        }
        else if (pass.isCancelled) {
            reasonID = swipeEvents.VP_CANCELLED_ID;
            reasonDescription = swipeEvents.VP_CANCELLED_MESSAGE;
        }
        else if (pass.isExpired) {
            reasonID = swipeEvents.VP_INVALID_DATE_ID;
            reasonDescription = swipeEvents.VP_INVALID_DATE_MESSAGE;
        }

        return { canAward: reasonID === null, reasonID, reasonDescription };
    }

    validateCompetence(card) {

        let reasonID = null;
        let reasonDescription = null;

        if (card.noSponsor) {
            reasonID = swipeEvents.NO_SPONSOR_ID;
            reasonDescription = swipeEvents.NO_SPONSOR_MESSAGE;
        } else if (card.noEmployer) {
            reasonID = swipeEvents.NO_PRIMARY_EMPLOYER_ID;
            reasonDescription = swipeEvents.NO_PRIMARY_EMPLOYER_MESSAGE;
        }
        else if (card.isNationallySuspended) {
            reasonID = swipeEvents.CARD_SUSPENDED_ID;
            reasonDescription = swipeEvents.CARD_SUSPENDED_MESSAGE;
        }
        else if (card.isSuspendedByDivision) {
            reasonID = swipeEvents.CARD_SUSPENDED_FOR_DIVISION_ID;
            reasonDescription = card.warningMessage;
        }
        else if (card.isSuspendedBySite) {
            reasonID = swipeEvents.CARD_SUSPENDED_FOR_SITE_ID;
            reasonDescription = card.warningMessage;
        }
        else if (card.isSubscriptionExpired) {
            reasonID = swipeEvents.WORKER_SUBSCRIPTION_EXPIRED_ID;
            reasonDescription = swipeEvents.WORKER_SUBSCRIPTION_EXPIRED_MESSAGE;
        }
        else if (card.isSubscriptionPending) {
            reasonID = swipeEvents.WORKER_SUBSCRIPTION_PENDING_ID;
            reasonDescription = swipeEvents.WORKER_SUBSCRIPTION_PENDING_MESSAGE;
        }
        else if (card.isExpired) {
            reasonID = swipeEvents.CARD_EXPIRED_ID;
            reasonDescription = swipeEvents.CARD_EXPIRED_MESSAGE;
        }
        else if (card.isCancelled) {
            reasonID = swipeEvents.CARD_CANCELLED_ID;
            reasonDescription = swipeEvents.CARD_CANCELLED_MESSAGE;
        }
        else if (card.isSuspended) {
            reasonID = swipeEvents.CARD_SUSPENDED_ID;
            reasonDescription = swipeEvents.CARD_SUSPENDED_MESSAGE;
        }

        return { canAward: reasonID === null, reasonID, reasonDescription };
    }

    validateSwipeOut(card) {

        let reasonID = null;
        let reasonDescription = null;

        if (card.noSponsor) {
            reasonID = swipeEvents.NO_SPONSOR_ID;
            reasonDescription = swipeEvents.NO_SPONSOR_MESSAGE;
        } else if (card.noEmployer) {
            reasonID = swipeEvents.NO_PRIMARY_EMPLOYER_ID;
            reasonDescription = swipeEvents.NO_PRIMARY_EMPLOYER_MESSAGE;
        }
        else if (card.isNationallySuspended) {
            reasonID = swipeEvents.CARD_SUSPENDED_ID;
            reasonDescription = swipeEvents.CARD_SUSPENDED_MESSAGE;
        }
        else if (card.isSuspendedByDivision) {
            reasonID = swipeEvents.CARD_SUSPENDED_FOR_DIVISION_ID;
            reasonDescription = card.warningMessage;
        }
        else if (card.isSuspendedBySite) {
            reasonID = swipeEvents.CARD_SUSPENDED_FOR_SITE_ID;
            reasonDescription = card.warningMessage;
        }
        else if (card.isSubscriptionExpired) {
            reasonID = swipeEvents.WORKER_SUBSCRIPTION_EXPIRED_ID;
            reasonDescription = swipeEvents.WORKER_SUBSCRIPTION_EXPIRED_MESSAGE;
        }
        else if (card.isSubscriptionPending) {
            reasonID = swipeEvents.WORKER_SUBSCRIPTION_PENDING_ID;
            reasonDescription = swipeEvents.WORKER_SUBSCRIPTION_PENDING_MESSAGE;
        }
        else if (card.isCancelled) {
            reasonID = swipeEvents.CARD_CANCELLED_ID;
            reasonDescription = swipeEvents.CARD_CANCELLED_MESSAGE;
        }
        else if (card.isSuspended) {
            reasonID = swipeEvents.CARD_SUSPENDED_ID;
            reasonDescription = swipeEvents.CARD_SUSPENDED_MESSAGE;
        }
        else if (card.isExpired) {
            reasonID = swipeEvents.CARD_EXPIRED_ID;
            reasonDescription = swipeEvents.CARD_EXPIRED_MESSAGE;
        }
        else if (card.missingCompetences) {
            if (Object.values(card.missingMultipleCompetences).filter(x => x).length > 1) {
                reasonID = swipeEvents.INVALID_COMPETENCES_MULTIPLE_ID;
                reasonDescription = swipeEvents.INVALID_COMPETENCES_MULTIPLE_MESSAGE;

            } else if (card.missingMultipleCompetences.employer) {
                reasonID = swipeEvents.INVALID_COMPETENCES_EMPLOYER_ID;
                reasonDescription = swipeEvents.INVALID_COMPETENCES_EMPLOYER_MESSAGE;

            }
            else if (card.missingMultipleCompetences.division) {
                reasonID = swipeEvents.INVALID_COMPETENCES_DIVISION_ID;
                reasonDescription = swipeEvents.INVALID_COMPETENCES_DIVISION_MESSAGE;

            } else if (card.missingMultipleCompetences.project) {
                reasonID = swipeEvents.INVALID_COMPETENCES_PROJECT_ID;
                reasonDescription = swipeEvents.INVALID_COMPETENCES_PROJECT_MESSAGE;

            } else if (card.missingMultipleCompetences.site) {
                reasonID = swipeEvents.INVALID_COMPETENCES_SITE_ID;
                reasonDescription = swipeEvents.INVALID_COMPETENCES_SITE_MESSAGE;

            } else if (card.missingMultipleCompetences.zone) {
                reasonID = swipeEvents.INVALID_COMPETENCES_ZONE_ID;
                reasonDescription = swipeEvents.INVALID_COMPETENCES_ZONE_MESSAGE;

            } else if (card.missingMultipleCompetences.card) {
                reasonID = swipeEvents.INVALID_COMPETENCES_CARD_ID;
                reasonDescription = swipeEvents.INVALID_COMPETENCES_CARD_MESSAGE;
            }
            else if (card.missingMultipleCompetences.national) {
                reasonID = swipeEvents.INVALID_COMPETENCES_NATIONAL_ID;
                reasonDescription = swipeEvents.INVALID_COMPETENCES_NATIONAL_MESSAGE;

            } else {
                reasonID = swipeEvents.INVALID_COMPETENCES_ID;
                reasonDescription = swipeEvents.INVALID_COMPETENCES_MESSAGE;
            }
        }

        return { canSwipeIn: reasonID === null, reasonID, reasonDescription };
    }

    validateSwipeIn(card) {

        let reasonID = null;
        let reasonDescription = null;

        if (card.noSponsor) {
            reasonID = swipeEvents.NO_SPONSOR_ID;
            reasonDescription = swipeEvents.NO_SPONSOR_MESSAGE;
        } else if (card.noEmployer) {
            reasonID = swipeEvents.NO_PRIMARY_EMPLOYER_ID;
            reasonDescription = swipeEvents.NO_PRIMARY_EMPLOYER_MESSAGE;
        }
        else if (card.isNationallySuspended) {
            reasonID = swipeEvents.CARD_SUSPENDED_ID;
            reasonDescription = swipeEvents.CARD_SUSPENDED_MESSAGE;
        }
        else if (card.isSuspendedByDivision) {
            reasonID = swipeEvents.CARD_SUSPENDED_FOR_DIVISION_ID;
            reasonDescription = card.warningMessage;
        }
        else if (card.isSuspendedBySite) {
            reasonID = swipeEvents.CARD_SUSPENDED_FOR_SITE_ID;
            reasonDescription = card.warningMessage;
        }
        else if (card.isSubscriptionExpired) {
            reasonID = swipeEvents.WORKER_SUBSCRIPTION_EXPIRED_ID;
            reasonDescription = swipeEvents.WORKER_SUBSCRIPTION_EXPIRED_MESSAGE;
        }
        else if (card.isSubscriptionPending) {
            reasonID = swipeEvents.WORKER_SUBSCRIPTION_PENDING_ID;
            reasonDescription = swipeEvents.WORKER_SUBSCRIPTION_PENDING_MESSAGE;
        }
        else if (card.isCancelled) {
            reasonID = swipeEvents.CARD_CANCELLED_ID;
            reasonDescription = swipeEvents.CARD_CANCELLED_MESSAGE;
        }
        else if (card.isSuspended) {
            reasonID = swipeEvents.CARD_SUSPENDED_ID;
            reasonDescription = swipeEvents.CARD_SUSPENDED_MESSAGE;
        }
        else if (card.isExpired) {
            reasonID = swipeEvents.CARD_EXPIRED_ID;
            reasonDescription = swipeEvents.CARD_EXPIRED_MESSAGE;
        }
        else if (card.missingCompetences) {
            if (Object.values(card.missingMultipleCompetences).filter(x => x).length > 1) {
                reasonID = swipeEvents.INVALID_COMPETENCES_MULTIPLE_ID;
                reasonDescription = swipeEvents.INVALID_COMPETENCES_MULTIPLE_MESSAGE;

            } else if (card.missingMultipleCompetences.employer) {
                reasonID = swipeEvents.INVALID_COMPETENCES_EMPLOYER_ID;
                reasonDescription = swipeEvents.INVALID_COMPETENCES_EMPLOYER_MESSAGE;

            }
            else if (card.missingMultipleCompetences.division) {
                reasonID = swipeEvents.INVALID_COMPETENCES_DIVISION_ID;
                reasonDescription = swipeEvents.INVALID_COMPETENCES_DIVISION_MESSAGE;

            } else if (card.missingMultipleCompetences.project) {
                reasonID = swipeEvents.INVALID_COMPETENCES_PROJECT_ID;
                reasonDescription = swipeEvents.INVALID_COMPETENCES_PROJECT_MESSAGE;

            } else if (card.missingMultipleCompetences.site) {
                reasonID = swipeEvents.INVALID_COMPETENCES_SITE_ID;
                reasonDescription = swipeEvents.INVALID_COMPETENCES_SITE_MESSAGE;

            } else if (card.missingMultipleCompetences.zone) {
                reasonID = swipeEvents.INVALID_COMPETENCES_ZONE_ID;
                reasonDescription = swipeEvents.INVALID_COMPETENCES_ZONE_MESSAGE;

            } else if (card.missingMultipleCompetences.card) {
                reasonID = swipeEvents.INVALID_COMPETENCES_CARD_ID;
                reasonDescription = swipeEvents.INVALID_COMPETENCES_CARD_MESSAGE;
            }
            else if (card.missingMultipleCompetences.national) {
                reasonID = swipeEvents.INVALID_COMPETENCES_NATIONAL_ID;
                reasonDescription = swipeEvents.INVALID_COMPETENCES_NATIONAL_MESSAGE;

            } else {
                reasonID = swipeEvents.INVALID_COMPETENCES_ID;
                reasonDescription = swipeEvents.INVALID_COMPETENCES_MESSAGE;
            }
        }
        return { canSwipeIn: reasonID === null, reasonID, reasonDescription };
    }

    validateVisitorPassSwipeIn(visitorPass) {

        let reasonID = null;
        let reasonDescription = null;

        if (visitorPass.isInvalidSite) {
            reasonID = swipeEvents.VP_INVALID_SITE_ID;
            reasonDescription = swipeEvents.VP_INVALID_SITE_MESSAGE;
        }
        else if (visitorPass.isCancelled) {
            reasonID = swipeEvents.VP_CANCELLED_ID;
            reasonDescription = swipeEvents.VP_CANCELLED_MESSAGE;
        }
        else if (visitorPass.notYetValid) {
            reasonID = swipeEvents.VP_INVALID_DATE_ID;
            reasonDescription = swipeEvents.VP_INVALID_DATE_MESSAGE;
        }
        else if (visitorPass.isExpired) {
            reasonID = swipeEvents.VP_INVALID_DATE_ID;
            reasonDescription = swipeEvents.VP_INVALID_DATE_MESSAGE;
        }

        return { canSwipeIn: reasonID === null, reasonID, reasonDescription };
    }

    spotCheck(card, location, cardCheckerCard) {

        const newSwipe = this.createBaseSwipe(card, location, cardCheckerCard);

        newSwipe.displayMode = displayMode.spotCheck;

        if (card.swipeType === swipeTypes.Manual) {
            newSwipe.swipeEvent = swipeEvents.CARDLESS_CHECK;
        } else {
            newSwipe.swipeEvent = swipeEvents.CARD_CHECK;
        }

        newSwipe.swipeOutcome = card.missingCompetences;
        return newSwipe;
    }

    spotCheckVisitorPass(pass, location, cardCheckerCard) {

        const newSwipe = this.createBaseSwipeForVisitorPass(pass, location, cardCheckerCard);

        newSwipe.displayMode = displayMode.spotCheck;
        newSwipe.swipeEvent = swipeEvents.VP_CHECK;
        newSwipe.swipeOutcome = true;

        return newSwipe;
    }

    swipeVisitorPassIn(pass, location, cardCheckerCard) {

        const swipeResult = this.validateVisitorPassSwipeIn(pass);
        const newSwipe = this.createBaseSwipeForVisitorPass(pass, location, cardCheckerCard);

        newSwipe.displayMode = displayMode.swipeIn;

        if (!swipeResult.canSwipeIn) {
            newSwipe.swipeEvent = swipeEvents.VP_ACCESS_DENIED_SENTINEL;
            newSwipe.swipeOutcome = false;
            newSwipe.denyReasonID = swipeResult.reasonID;
            newSwipe.denyReasonDescription = swipeResult.reasonDescription;
        } else {
            newSwipe.swipeEvent = swipeEvents.VP_SWIPE;
            newSwipe.swipeOutcome = true;
        }

        return newSwipe;
    }

    swipeIn(
        card,
        location,
        cardCheckerCard,
        swipeType,
        travelTimeFromPlaceOfRestHours,
        travelTimeFromPlaceOfRestMinutes,
        travelTimeToPlaceOfRestHours,
        travelTimeToPlaceOfRestMinutes,
        jobRoleID,
        employerID,
        associationEmployerID,
        fromFuelID,
        toFuelID,
        fromTravelMethodID,
        toTravelMethodID,
        fromTravelDistance,
        toTravelDistance) {

        const swipeResult = this.validateSwipeIn(card);
        const newSwipe = this.createBaseSwipe(card, location, cardCheckerCard);

        newSwipe.displayMode = displayMode.swipeIn;

        if (!swipeResult.canSwipeIn) {

            newSwipe.swipeEvent = swipeEvents.ACCESS_DENIED_SENTINEL;
            newSwipe.swipeOutcome = false;
            newSwipe.denyReasonID = swipeResult.reasonID;
            newSwipe.denyReasonDescription = swipeResult.reasonDescription;

        } else {

            if (swipeType === swipeTypes.Manual) {
                newSwipe.swipeEvent = swipeEvents.CARDLESS_SWIPE;
            } else {
                newSwipe.swipeEvent = swipeEvents.CARD_SWIPE;
            }

            newSwipe.swipeType = swipeType;
            newSwipe.swipeOutcome = true;
            newSwipe.travelTimeFromPlaceOfRestHours = travelTimeFromPlaceOfRestHours || 0;
            newSwipe.travelTimeFromPlaceOfRestMinutes = travelTimeFromPlaceOfRestMinutes || 0;
            newSwipe.travelTimeToPlaceOfRestHours = travelTimeToPlaceOfRestHours || 0;
            newSwipe.travelTimeToPlaceOfRestMinutes = travelTimeToPlaceOfRestMinutes || 0;
            newSwipe.jobRoleID = jobRoleID;
            newSwipe.employerID = employerID;
            newSwipe.associationEmployerID = associationEmployerID;
            newSwipe.fromTravelMethodID = fromTravelMethodID;
            newSwipe.toTravelMethodID = toTravelMethodID;
            newSwipe.fromFuelID = fromFuelID;
            newSwipe.toFuelID = toFuelID;
            newSwipe.fromTravelDistance = fromTravelDistance || 0;
            newSwipe.toTravelDistance = toTravelDistance || 0;
        }

        return newSwipe;
    }

    swipeOutVisitorPass(pass, location, cardCheckerCard) {

        const newSwipe = this.createBaseSwipeForVisitorPass(pass, location, cardCheckerCard);

        newSwipe.displayMode = displayMode.swipeOut;
        newSwipe.swipeEvent = swipeEvents.VP_SWIPE_OUT;
        newSwipe.swipeOutcome = true;
        return newSwipe;
    }

    swipeOut(
        card,
        location,
        cardCheckerCard,
        travelTimeFromPlaceOfRestHours,
        travelTimeFromPlaceOfRestMinutes,
        travelTimeToPlaceOfRestHours,
        travelTimeToPlaceOfRestMinutes,
        fromFuelID,
        toFuelID,
        fromTravelMethodID,
        toTravelMethodID,
        fromTravelDistance,
        toTravelDistance) {

        const newSwipe = this.createBaseSwipe(card, location, cardCheckerCard);

        // swipe outs are always permitted, but the system needs to display what would have
        // been the denial reason.  This is captured during the initial swipe out process,
        // but the reason also needs to be persisted with the swipe data so it can be
        // rendered back when a user views an historic swipe.  The denyReasonID is NOT
        // stored on the swipe as this would cause it to be sent back to the server
        // as a denial. It's all a bit of a hack as it relies on the rendering behaviour
        // looking at the denial description to show up in the card holder view for the
        // historic swipe, but not used in the swipe list
        const validationResult = this.validateSwipeOut(card);
        newSwipe.denyReasonDescription = validationResult.reasonDescription;

        newSwipe.displayMode = displayMode.swipeOut;

        if (card.swipeType === swipeTypes.Manual) {
            newSwipe.swipeEvent = swipeEvents.CARDLESS_SWIPE_OUT;
        } else {
            newSwipe.swipeEvent = swipeEvents.CARD_SWIPE_OUT;
        }
        newSwipe.swipeOutcome = true;

        newSwipe.travelTimeFromPlaceOfRestHours = travelTimeFromPlaceOfRestHours || 0;
        newSwipe.travelTimeFromPlaceOfRestMinutes = travelTimeFromPlaceOfRestMinutes || 0;
        newSwipe.travelTimeToPlaceOfRestHours = travelTimeToPlaceOfRestHours || 0;
        newSwipe.travelTimeToPlaceOfRestMinutes = travelTimeToPlaceOfRestMinutes || 0;
        newSwipe.fromTravelMethodID = fromTravelMethodID;
        newSwipe.toTravelMethodID = toTravelMethodID;
        newSwipe.fromFuelID = fromFuelID;
        newSwipe.toFuelID = toFuelID;
        newSwipe.fromTravelDistance = fromTravelDistance || 0;
        newSwipe.toTravelDistance = toTravelDistance || 0;

        return newSwipe;
    }

    manualDenyVisitorPass(pass, location, cardCheckerCard, denyReason) {

        const newSwipe = this.createBaseSwipeForVisitorPass(pass, location, cardCheckerCard);

        newSwipe.displayMode = displayMode.none;
        newSwipe.swipeEvent = swipeEvents.VP_ACCESS_DENIED_SITE;
        newSwipe.swipeOutcome = false;
        newSwipe.denyReasonID = denyReason.reasonID;
        newSwipe.denyReasonDescription = denyReason.reasonDescription;

        return newSwipe;
    }

    manualDeny(card, location, cardCheckerCard, denyReason) {

        const newSwipe = this.createBaseSwipe(card, location, cardCheckerCard);

        newSwipe.displayMode = displayMode.none;
        newSwipe.swipeEvent = swipeEvents.ACCESS_DENIED_SITE;
        newSwipe.swipeOutcome = false;
        newSwipe.denyReasonID = denyReason.reasonID;
        newSwipe.denyReasonDescription = denyReason.reasonDescription;

        return newSwipe;
    }

    denyCompetence(card, location, cardCheckerCard, competence, denyReason) {

        const newSwipe = this.createBaseSwipe(card, location, cardCheckerCard);

        newSwipe.displayMode = displayMode.awardCompetence;
        newSwipe.swipeEvent = swipeEvents.AWARD_COMPETENCE_DENIED;

        newSwipe.swipeOutcome = false;
        newSwipe.denyReasonID = denyReason.reasonID;
        newSwipe.denyReasonDescription = denyReason.reasonDescription;

        newSwipe.competenceID = competence.competenceID;
        newSwipe.competenceName = competence.name;

        return newSwipe;
    }

    denyCompetenceVisitorPass(pass, location, cardCheckerCard, competence, denyReason) {

        const newSwipe = this.createBaseSwipeForVisitorPass(pass, location, cardCheckerCard);

        newSwipe.displayMode = displayMode.awardCompetence;
        newSwipe.swipeEvent = swipeEvents.VP_AWARD_COMPETENCE_DENIED;

        newSwipe.swipeOutcome = false;
        newSwipe.denyReasonID = denyReason.reasonID;
        newSwipe.denyReasonDescription = denyReason.reasonDescription;

        newSwipe.competenceID = competence.competenceID;
        newSwipe.competenceName = competence.name;

        return newSwipe;
    }

    awardCompetence(card, location, cardCheckerCard, competence, expiryDate, certificate) {

        const newSwipe = this.createBaseSwipe(card, location, cardCheckerCard);

        newSwipe.displayMode = displayMode.awardCompetence;

        if (card.swipeType === swipeTypes.Manual) {
            newSwipe.swipeEvent = swipeEvents.CARDLESS_AWARD_COMPETENCE;
        } else {
            newSwipe.swipeEvent = swipeEvents.AWARD_COMPETENCE;
        }

        newSwipe.swipeOutcome = true;
        newSwipe.competenceID = competence.competenceID;
        newSwipe.competenceName = competence.name;
        newSwipe.certificate = certificate;

        if (expiryDate) {
            newSwipe.competenceExpiryDate = expiryDate;
        }

        return newSwipe;
    }

    awardCompetenceToVisitorPass(pass, location, cardCheckerCard, competence, expiryDate, certificate) {

        const newSwipe = this.createBaseSwipeForVisitorPass(pass, location, cardCheckerCard);

        newSwipe.displayMode = displayMode.awardCompetence;
        newSwipe.swipeEvent = swipeEvents.VP_AWARD_COMPETENCE;
        newSwipe.swipeOutcome = true;
        newSwipe.competenceID = competence.competenceID;
        newSwipe.competenceName = competence.name;
        newSwipe.certificate = certificate;

        if (expiryDate) {
            newSwipe.competenceExpiryDate = expiryDate;
        }

        return newSwipe;
    }

    createBaseSwipeForVisitorPass(pass, location, cardCheckerCard) {

        return {
            divisionID: location.division.divisionID,
            projectID: location.project.projectID,
            projectName: location.project.projectName,
            siteID: location.site.siteID,
            siteCode: location.site.siteCode,
            siteName: location.site.siteName,
            zoneID: location.zone ? location.zone.zoneID : null,
            zoneCode: location.zone ? location.zone.zoneCode : '',
            zoneName: location.zone ? location.zone.zoneName : '',
            swipeType: swipeTypes.QR,
            cardCheckSerialNumber: cardCheckerCard.serialNumber,
            cardCheckerCardNumber: cardCheckerCard.qrCode,
            utcSwipeDate: DateTime.local().toISO(),
            swipeTime: new Date().toISOString(),
            uploadedToServer: false,
            loadedFromCache: true,
            logicalDelete: false,
            visitorPass: pass.pass
        };
    }

    createBaseSwipe(card, location, cardCheckerCard) {

        return {
            projectID: location.project.projectID,
            projectName: location.project.projectName,
            divisionID: location.division.divisionID,
            siteID: location.site.siteID,
            siteCode: location.site.siteCode,
            siteName: location.site.siteName,
            zoneID: location.zone ? location.zone.zoneID : null,
            zoneCode: location.zone ? location.zone.zoneCode : '',
            zoneName: location.zone ? location.zone.zoneName : '',
            swipeType: swipeTypes.QR,
            cardCheckSerialNumber: cardCheckerCard.serialNumber,
            cardCheckerCardNumber: cardCheckerCard.qrCode,
            utcSwipeDate: DateTime.local().toISO(),
            swipeTime: new Date().toISOString(),
            uploadedToServer: false,
            loadedFromCache: true,
            logicalDelete: false,
            serialNumber: card.serialNumber,
            qrCode: card.qrCode,

            card: card
        };
    }
}